export default {
  webRecruiter: `Web Recruiter`,
  title: `Unsubscribe`,
  subTitle: ` By unsubscribing, you will be missing important updates about the job openings in and around your area. Do you still want to unsubscribe?`,
  unSubscribeBtn: 'UNSUBSCRIBE',
  cancel: 'CANCEL',
  unSubscribeError: "Couldn't unsubscribe at the moment. Please Try again later.",
};
